import { getTranslateByScope } from '../../i18n';

export const translate = getTranslateByScope('app.orderList');
